module.exports = __webpack_public_path__ + "img/vepa.4b703340.png";